export class TakeoffHome {
    activate() {
    }
}